import Footer from '@/components/@next/layout/Footer/Footer';
import { useIsMobile } from '@/hooks/useIsMobile';
import { ReactNode } from 'react';
import Header from '../components/Header';

export default function BlogLayout({ children }: { children: ReactNode }) {
  const isMobile = useIsMobile();
  return (
    <div style={{ minHeight: '100vh' }} className="flex flex-col justify-between">
      <div className="py-10 px-2 md:px-20">
        <Header />
        {children}
      </div>
      <Footer />
    </div>
  );
}
